import { AuthState, type AuthStateType } from './constants';

import type { User } from 'oidc-client-ts';


export function getUserRole(user: User | null): AuthStateType {
  if (user) {
    const roles = Array.isArray(user.profile.role) ? user.profile.role : [user.profile.role];

    if (roles.includes('Administrator')) {
      return AuthState.globalAdministrator;
    } else if (roles.includes('Moderator')) {
      return AuthState.insuranceAgentAdministrator;
    } else if (roles.includes('Agent')) {
      return AuthState.insuranceAgent;
    } else if (roles.includes('Viewer')) {
      return AuthState.stakeholder;
    } else {
      return AuthState.producer;
    }
  } else {
    return AuthState.guest;
  }
}
